/*
 * Copyright (c) 2023. Collabro Limited
 */

import { createTheme, PaletteMode, responsiveFontSizes } from "@mui/material";
import COLLABRO from "./COLLABRO/COLLABRO";
import { ThemeOptions } from "@mui/material/styles";
import MODEC from "./MODEC/MODEC";

/**
 * Decide on a theme by looking at the env
 *
 * @since 0.1.0
 * @returns {ThemeOptions} - Company Theme configuration
 */
const themeChooser = (mode: PaletteMode): ThemeOptions => {
  //TODO: Implement Company Theme based on process.env.REACT_APP_THEME
  console.log(process.env.REACT_APP_THEME);
  switch (process.env.REACT_APP_THEME) {
    case "MODEC":
      return MODEC(mode);
    default:
      return COLLABRO(mode);
  }
};

export const getTheme = (mode: PaletteMode) => {
  return responsiveFontSizes(createTheme(themeChooser(mode)));
};
